import { useImperativeHandle } from 'react';
import { reportError } from '../utility/debug.js'; // Adds instance methods to the React component.

export default function useInstanceMethods(ref, _ref) {
  var virtualScroller = _ref.virtualScroller;
  useImperativeHandle(ref, function () {
    return {
      // This is a proxy for `VirtualScroller`'s `.updateLayout` instance method.
      updateLayout: function updateLayout() {
        virtualScroller.updateLayout();
      },
      // (deprecated)
      // `.layout()` method name is deprecated, use `.updateLayout()` instead.
      layout: function layout() {
        virtualScroller.updateLayout();
      },
      // (deprecated)
      updateItem: function updateItem(i) {
        reportError("\".updateItem(i)\" method of React <VirtualScroller/> has been removed");
      },
      // (deprecated)
      renderItem: function renderItem(i) {
        reportError("\".renderItem(i)\" method of React <VirtualScroller/> has been removed");
      }
    };
  }, [virtualScroller]);
}
//# sourceMappingURL=useInstanceMethods.js.map